import { addLoadingState, removeLoadingState } from "../../store/spa-app-actions.js";
import { pdStore } from "../../store/mini-rx.store.js";
import { services } from "../../service-provider/ServiceRegistry.js";
import __decorate from "../../_virtual/_@oxc-project_runtime@0.147.0/helpers/esm/decorate.js";
import { LitElement, css, html } from "lit";
import { customElement, state } from "lit/decorators.js";
import "@progressive-development/pd-page/pd-login";
//#region src/components/default-login/DefaultLogin.ts
var LOGIN_LOADING_KEY = "login-attempt";
var PASSWORD_RESET_LOADING_KEY = "password-reset-attempt";
var DefaultLogin = class DefaultLogin extends LitElement {
	constructor(..._args) {
		super(..._args);
		this._loading = false;
		this._errorMessage = "";
		this._successMessage = "";
	}
	static {
		this.styles = [css`
      :host {
        padding-top: 3em;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    `];
	}
	render() {
		return html`
      <pd-login
        ?loading="${this._loading}"
        errorMessage="${this._errorMessage}"
        successMessage="${this._successMessage}"
        @login-attempt="${this._handleLoginAttempt}"
        @forgot-password-attempt="${this._handleForgotPasswordAttempt}"
        @view-change="${this._handleViewChange}"
      ></pd-login>
    `;
	}
	_handleViewChange() {
		this._errorMessage = "";
	}
	_handleLoginAttempt(e) {
		this._loading = true;
		this._errorMessage = "";
		this._successMessage = "";
		pdStore().dispatch(addLoadingState({
			actionKey: LOGIN_LOADING_KEY,
			isLoading: true,
			modal: true,
			loadingTxt: "Anmeldung..."
		}));
		services.auth.login(e.detail.email, e.detail.password).then((user) => {
			this.dispatchEvent(new CustomEvent("login-success", {
				detail: user,
				bubbles: true,
				composed: true
			}));
		}).catch((error) => {
			this._errorMessage = this._mapErrorCode(error.code || "unknown");
		}).finally(() => {
			this._loading = false;
			pdStore().dispatch(removeLoadingState(LOGIN_LOADING_KEY));
		});
	}
	_handleForgotPasswordAttempt(e) {
		this._loading = true;
		this._errorMessage = "";
		this._successMessage = "";
		pdStore().dispatch(addLoadingState({
			actionKey: PASSWORD_RESET_LOADING_KEY,
			isLoading: true,
			modal: false,
			smallBackground: true,
			loadingTxt: "E-Mail wird gesendet..."
		}));
		services.auth.sendPasswordResetEmail(e.detail.email).then(() => {
			this._successMessage = "Wir haben Ihnen eine E-Mail zum Zurücksetzen des Passworts gesendet.";
		}).finally(() => {
			this._loading = false;
			pdStore().dispatch(removeLoadingState(PASSWORD_RESET_LOADING_KEY));
		});
	}
	_mapErrorCode(code) {
		switch (code) {
			case "auth/invalid-email": return "E-Mail Format für Benutzer ist ungültig.";
			case "auth/invalid-credential":
			case "auth/invalid-login-credentials":
			case "auth/wrong-password":
			case "auth/user-not-found": return "Anmeldung fehlgeschlagen, ungültige Benutzerdaten.";
			default: return "Technisches Problem aufgetreten, die Anmeldung kann leider aktuell nicht durchgeführt werden.";
		}
	}
};
__decorate([state()], DefaultLogin.prototype, "_loading", void 0);
__decorate([state()], DefaultLogin.prototype, "_errorMessage", void 0);
__decorate([state()], DefaultLogin.prototype, "_successMessage", void 0);
DefaultLogin = __decorate([customElement("default-login")], DefaultLogin);
//#endregion
export { DefaultLogin };
